<template>
    <div class="big">
        <div class="balance">
          <UploadOne v-model="form.avatar"></UploadOne>
          <div class="input">
              <div>修改昵称</div>
              <el-input v-model="form.nickname" placeholder="昵称仅限7个字"></el-input>
              <span>请输入新昵称，仅限文字、字母、数字、下划线</span>
          </div>
          <div class="input">
              <!-- <div>修改简介</div> -->
              <el-input v-model="form.profile" placeholder="请输入简介"></el-input>
              <!-- <span>请输入简介，仅限文字、字母、数字、下划线</span> -->
          </div>
          
          <div class="recharge-btn">
              <el-button type="primary" :loading="btnLoading" @click="saveData">保存</el-button>
          </div>
      </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from '@/components/UploadOne/index.vue'
import Cookies from 'js-cookie'
export default {
  components: { UploadOne },
  data() {
    return {
      btnLoading: false,
      form: {
        nickname: "",
        avatar: "",
        profile: ""
      },
    };
  },
  created() {
    this.form.nickname = this.$store.getters.getUserInfo.nickname;
    this.form.avatar = this.$store.getters.getUserInfo.avatar;
    this.form.profile = this.$store.getters.getUserInfo.profile;
  },
  methods: {
    info(){
      return request({
          url: '/api/userend/user/info',
          method: 'get',
          params: { }
        }).then(response =>{
          localStorage.setItem("userInfo",JSON.stringify(response.data))
          this.$store.commit("setUserInfo",JSON.parse(localStorage.getItem("userInfo")))
          this.btnLoading=false
          // Cookies.set('userInfo', JSON.stringify(response.data), { expires: 15 })
          // this.$store.commit("setUserInfo",JSON.parse(Cookies.get('userInfo')))
      })
    },
    saveData() {
      if(!this.form.nickname){
        this.$message.error("昵称不能为空！")
        return
      }
      if(!this.form.avatar){
        this.$message.error("头像不能为空！")
        return
      }
      this.btnLoading=true
      return request({
          url: '/api/userend/user/store',
          method: 'post',
          params: this.form
        }).then(response =>{
          this.$notify({
            title: "成功",
            message: "保存成功",
            type: "success",
            duration: 2000
          });
          this.btnLoading=false
          this.info()
          setTimeout(() => {
            this.$router.go(-1); //返回上一层
          }, 500);
      }).catch(() => {
        this.btnLoading=false
      });
      // this.$refs["form"].validate(valid => {
      //   if (valid) {
      //     this.btnLoading = true;
      //     request({
      //       url: "/api/backend/change_passwd",
      //       method: "post",
      //       data: this.form
      //     })
      //       .then(() => {
      //         this.btnLoading = false;
      //         this.$notify({
      //           title: "成功",
      //           message: "保存成功",
      //           type: "success",
      //           duration: 2000
      //         });
      //         setTimeout(() => {
      //           this.$router.go(-1); //返回上一层
      //         }, 500);
      //       })
      //       .catch(() => {
      //         this.btnLoading = false;
      //       });
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    // cancel() {
    //   this.$router.go(-1); //返回上一层
    // }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.big{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 150px;
  .balance{
        width: 100%;
        //  background: #FFFFFF;
        .balance-num{
           background: #FFFFFF;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 120px;
            height: 120px;
            margin: 0 auto;
            position: relative;
            margin-bottom: 30px;
            img{
                &:nth-child(1){
                    width: 120px;
                    height: 120px;
                    border-radius: 50%;
                }
                &:nth-child(2){
                    width: 37px;
                    height: 37px;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                }
            }
        }
        .input{
            width: 336px;
            margin: 0 auto;
            margin-top: 20px;
            border-radius: 8px;
            .el-input{
              background: #FFFFFF;
              border: 1px solid #dbdce0;
              border-radius: 8px;
            }
            .el-input__inner{
                width: 336px;
                height: 57px;
                background: #F9FAFD;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                margin: 0 auto;
                border-radius: 8px;
                margin-bottom: 15px;
            }
            div{
                text-align: center;
                font-size: 22px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1E2134;
                margin-bottom: 15px;
            }
            span{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #858585;
            }
        }
       
        .recharge-btn{
                width: 336px;
                height: 50px;
                margin: 0 auto;
                margin-top: 30px;
                .el-button{
                    width: 336px;
                    height: 50px;
                    margin: 0 auto;
                    background: #3D7EFF;
                    border-radius: 6px;
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
        }
    }
    }
</style>
